import { render, staticRenderFns } from "./ClientProfileEditForm.vue?vue&type=template&id=b4c5d8ec&scoped=true&"
import script from "./ClientProfileEditForm.vue?vue&type=script&lang=js&"
export * from "./ClientProfileEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileEditForm.vue?vue&type=style&index=0&id=b4c5d8ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5d8ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})
